<template>
  <div class="pa-6 bg-custom">
    <v-row no-gutters class="mb-2">
      <v-col xl="11" cols="10" class="pt-3">
        <h2>
          {{
            $vuetify.lang.t('$vuetify.courseManagement.stepCourse.courseDetail')
          }}
        </h2>
      </v-col>
      <!-- <v-col xl="1" cols="2">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-row v-on="on" justify="end" no-gutters>
              <v-col xl="6" cols="5">
                <v-switch
                  v-model="activeStatus"
                  @change="openModalStatus()"
                  inset
                ></v-switch>
              </v-col>
            </v-row>
          </template>
          <span v-if="activeStatus">Click to Suspend</span>
          <span v-else>Click to Activate</span>
        </v-tooltip>
      </v-col> -->
    </v-row>

    <v-form ref="form" v-model="valid" v-on:submit.prevent="onUpload">
      <v-sheet color="white" class="mb-6 pa-6">
        <v-row>
          <v-col lg="6" md="6" sm="6" cols="12">
            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{ $vuetify.lang.t('$vuetify.courseNameTh') }}
              <span class="red--text">*</span>
            </p>
            <v-text-field
              outlined
              v-model="courseName"
              :rules="nameRules"
              :placeholder="$vuetify.lang.t('$vuetify.courseNameTh')"
              required
              clearable
              background-color="white"
              @change="universalHistory('EDIT_NAME_TH')"
            ></v-text-field>
            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{ $vuetify.lang.t('$vuetify.courseNameEng') }}
              <span class="red--text">*</span>
            </p>
            <v-text-field
              outlined
              :rules="nameEngRules"
              v-model="courseNameEng"
              :placeholder="$vuetify.lang.t('$vuetify.courseNameEng')"
              clearable
              background-color="white"
              @change="universalHistory('EDIT_NAME_EN')"
            ></v-text-field>
            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{ $vuetify.lang.t('$vuetify.courseDescription') }}
            </p>
            <quill-editor
              class="mb-5 editor detail-editor"
              v-model="description"
              ref="description"
              :value="description"
              :options="editorOption"
              @change="onEditorChange"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
            />

            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{ $vuetify.lang.t('$vuetify.discussionBoard') }}
              <span class="red--text">*</span>
            </p>
            <v-radio-group class="pl-3" v-model="useBoard" row>
              <v-radio
                :label="$vuetify.lang.t('$vuetify.enable')"
                :value="true"
                @change="universalHistory('EDIT_USE_DISCUSSION_BOARD')"
              ></v-radio>
              <v-radio
                :label="$vuetify.lang.t('$vuetify.disable')"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col lg="6" md="6" sm="6" cols="12">
            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{ $vuetify.lang.t('$vuetify.category') }}
              <span class="red--text">*</span>
            </p>
            <v-autocomplete
              v-model="selectedCategories"
              :items="categories"
              item-text="title"
              item-value="_id"
              :placeholder="$vuetify.lang.t('$vuetify.chooseCategory')"
              outlined
              required
              :rules="categoryRules"
              background-color="white"
              @change="universalHistory('EDIT_CATEGORY')"
            ></v-autocomplete>
            <!-- <p class="mb-2 body-1 font-weight-medium text-custom-title">
            {{ $vuetify.lang.t('$vuetify.level') }}
            <span class="red--text">*</span>
          </p>
          <v-combobox
            v-model="selectedGrade"
            :items="grades"
            item-text="title"
            background-color="white"
            outlined
            :placeholder="$vuetify.lang.t('$vuetify.chooseLevel')"
            :rules="gradeRules"
            small-chips
            multiple
            @change="onLevelChange"
          ></v-combobox> -->
            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{ $vuetify.lang.t('$vuetify.skill') }}
              <span class="red--text">*</span>
            </p>
            <v-combobox
              v-model="selectedSkills"
              :items="skills"
              item-text="title"
              :placeholder="$vuetify.lang.t('$vuetify.chooseSkill')"
              outlined
              multiple
              @change="onSkillChange"
              :search-input.sync="searchSkill"
              required
              small-chips
              :rules="skillRules"
              background-color="white"
              :delimiters="[' ']"
            ></v-combobox>
            <v-alert class="custom-alert pt-0" text>
              <v-row>
                <v-col class="pa-0" lg="1" cols="1">
                  <v-icon color="info">mdi-information-outline</v-icon>
                </v-col>
                <v-col class="pa-0" lg="11" cols="11">
                  <div
                    v-html="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.detailStep.instructionSkill'
                      )
                    "
                  />
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet color="white" class="mb-6 pa-6">
        <v-row justify="center">
          <v-col lg="6" md="6" sm="12" cols="12">
            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.courseImage'
                )
              }}
            </p>
            <div v-if="imgPreview" class="image-preview2 border-card">
              <v-img contain :src="imgPreview" width="100%">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
            <div v-if="!imgPreview" class="image-preview border-card"></div>
            <v-row justify="center">
              <div class="upload-btn-wrapper mt-5">
                <button class="btn-choose body-1 font-weight-medium">
                  <v-icon>mdi-upload</v-icon>Choose file
                </button>
                <input
                  type="file"
                  name="myfile"
                  @change="preview"
                  accept="image/png, image/jpeg, image/bmp"
                />
              </div>
            </v-row>
            <v-row justify="center" class="mt-3">
              <p class="mb-0 text-custom body-2 font-weight-regular">
                Acceptable formats：.png .jpg only
              </p>
              <p class="mb-0 text-custom body-2 font-weight-regular">
                Max file size is 1MB
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <div class="d-flex justify-end">
        <v-btn class="body-1 custom-button mr-2" outlined @click="goBack">
          <v-icon left>mdi-arrow-left</v-icon>
          {{ $vuetify.lang.t('$vuetify.btnCourseList') }}
        </v-btn>
        <v-btn
          class="body-1"
          color="primary"
          :disabled="!valid || loadingbtn"
          :loading="loadingbtn"
          @click="onUpload"
          elevation="0"
        >
          <v-icon v-if="this.$route.query.id" left>mdi-check</v-icon>
          {{
            this.$route.query.id
              ? $vuetify.lang.t('$vuetify.save')
              : $vuetify.lang.t('$vuetify.create')
          }}
        </v-btn>
      </div>
    </v-form>

    <v-row justify="center">
      <v-dialog v-model="alert" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t('$vuetify.courseManagement.courseList.sorry')
          }}</v-card-title>
          <v-card-text>
            <div
              v-html="
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.alertPermissionFunction'
                )
              "
            ></div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="refreshPage">{{
              $vuetify.lang.t('$vuetify.courseManagement.detailStep.ok')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAddFail" max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.dialogAddFail.unsuccessfulEditing'
            )
          }}</v-card-title>

          <v-card-text>{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.dialogAddFail.errorEditing'
            )
          }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1" text @click="dialogAddFail = false">{{
              $vuetify.lang.t('$vuetify.defaultLayout.ok')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">บันทึกเรียบร้อย</v-card-title>

        <v-card-text>สามารถแก้ไขข้อมูลได้ภายหลัง</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false"
            >เสร็จสิ้น</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUnActiveCourse" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.courseList.confirmUnpublish'
            )
          }}
        </v-card-title>
        <v-card-text>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.courseList.unpublishDescript'
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            color="grey darken-1"
            outlined
            @click="cancelModalStatus()"
            >{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn
          >
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            dark
            color="error darken-1"
            @click="courseActive()"
            >{{ $vuetify.lang.t('$vuetify.confirm') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogActiveCourse" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.courseList.confirmPublish'
            )
          }}
        </v-card-title>
        <v-card-text>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.courseList.publishDescript'
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            color="grey darken-1"
            outlined
            @click="cancelModalStatus()"
            >{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn
          >
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 button-primary font-weight-light"
            dark
            @click="courseActive()"
            >{{ $vuetify.lang.t('$vuetify.confirm') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCantPublic" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t('$vuetify.courseManagement.courseList.failedToSave')
          }}
        </v-card-title>
        <v-card-text>{{ messageCantPublic }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="grey darken-1" dark rounded outlined @click="dialogCantPublic = false">ยกเลิก</v-btn> -->
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            dark
            color="error darken-1"
            @click="dialogCantPublic = false"
            >{{ $vuetify.lang.t('$vuetify.confirm') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { loadCategory } from '@/service/category/category';
import { loadSkill, insertSkill, loadSkillList } from '@/service/skill/skill';
import { loadGradeList } from '@/service/grade/grade';
import { loadTagList, insertTag } from '@/service/tag';
import {
  getCourseById,
  insertCourse,
  updateCourse,
  updateActive,
} from '@/service/course/course';
import { getRoom, insertRoom } from '@/service/room/room';
import { getLive } from '@/service/course/live';
// import { uploadImage } from "@/service/upload/upload";
import { headersWithTokenForImage, domain } from '@/service/configApi';
import axios from 'axios';
import { cleaningData } from '@/helper/cleaningData';
import {
  // getUserGroup,
  getlistCompany,
  getUserGroupCompany,
  getDetailCompany,
  setUserGroupToCourseByAdmin,
  setUserGroupToCourse,
} from '@/service/account/manageUserGroup';
import { getUserTeacherList } from '@/service/account/manageUser';
export default {
  data: function () {
    return {
      //edit
      history: [],
      admins: [],
      setOwner: false,
      isEdit: false,
      courseID: '',
      alert: false,
      dialogSuccess: false,
      dialogAddFail: false,
      error: 'Invalid Data! Please complete all information of the course!',
      success: 'Success, creating course!',
      timeout: 5000,
      imgPreview: '',
      imgPreview2: '',
      imageReady: false,
      imageReady2: false,
      certificate: false,
      percentCertificate: 80,
      valid: true,
      detail: {},
      rooms: [],
      courseName: '',
      courseNameEng: '',
      selectedCategories: [],
      selectInstructor: [],
      owner: [],
      selectedSkills: [],
      isPublicCourse: false,
      // selectedGrade: [],
      selectedTags: [],
      skillStatus: 0,
      skills: [],
      skillsId: [],
      gradeId: [],
      tagsId: [],
      instructorID: [],
      imageFile: null,
      imgURL: '',
      grades: [],
      tags: [],
      description: '',
      editorOption: {},
      nameRules: [
        (v) => !!v || this.$vuetify.lang.t('$vuetify.courseNameRule'),
      ],
      nameEngRules: [
        (v) => !!v || this.$vuetify.lang.t('$vuetify.courseNameEngRule'),
      ],
      instructorList: [],
      categoryId: [],
      categories: [],
      categoryRules: [
        (v) => !!v || this.$vuetify.lang.t('$vuetify.plsChooseCategory'),
        // v => (v && v.length >= 2) || "Category must be at least 2 characters"
      ],
      tradeRules: [
        (v) => !!v || this.$vuetify.lang.t('$vuetify.plsChooseTrade'),
      ],
      durationTypeRules: [
        (v) => !!v || this.$vuetify.lang.t('$vuetify.plsChooseDurationType'),
      ],
      priceRules: [
        (v) => !!v > 0 || this.$vuetify.lang.t('$vuetify.choosePrice'),
      ],
      typeDayRules: [
        (v) => !!v > 0 || this.$vuetify.lang.t('$vuetify.typeDay'),
      ],
      imageRules: [
        (v) =>
          !v ||
          v.size < 20000000 ||
          this.$vuetify.lang.t('$vuetify.plsChooseUnder20MB'),
      ],
      priceCourse: 1,

      learningOrder: false,
      haveDashboard: false,
      useBoard: false,
      haveInbox: false,
      activeStatus: false,
      dropdown_trade: [
        {
          text: 'ปิดการขายคอร์ส',
          value: 1,
        },
        {
          text: 'เปิดการขายคอร์ส',
          value: 2,
        },
      ],
      selectTrade: 1,
      dropdown_duration: [
        {
          text: 'ประเภทจำนวนวัน',
          value: 1,
        },
        {
          text: 'ประเภทกำหนดวันที่',
          value: 2,
        },
      ],
      selectDuration: 1,
      durationTypeDay: 1,
      typeExp: '',
      idcourse: '',
      dateExp: new Date().toISOString().substr(0, 10),
      dateStart: new Date().toISOString().substr(0, 10),
      dateEnd: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().slice(0, 10),

      menu: false,
      menu1: false,
      menu2: false,
      modal: false,
      menu_enddate: false,
      startTime: 0,
      endTime: 0,
      fixTime: 0,
      fixTimeStart: 0,
      hourExp: 0,
      minExp: 0,
      hourStart: 0,
      minStart: 0,
      hourEnd: 0,
      minEnd: 0,
      imgBool: false,
      imgBool2: false,

      // usergroup
      userGroupSelect: [],
      userGroup: [],

      snackbar: false,
      snackbar2: false,

      listCompany: [],
      listFilterCompany: [],
      listDetailCompany: [],
      listDetailTemp: [],
      selectedCompany: '',
      userGroupByAdmin: [],
      userGroupSelectByAdmin: [],
      companySelectByAdmin: '',
      indexSelectByAdmin: 0,
      companyModal: false,
      allGroup: [],
      searchCompany: '',

      //search
      searchByUserDialog: false,
      searchByAdminDialog: false,
      userGroupSearch: [],
      userGroupAllAtIndex: [],
      indexSelectIdForSearch: 0,

      setPercentTop: 0,
      setPercentLeft: 0,

      certificateStudentName: true,
      certificateCourseName: false,
      certificateDate: false,

      studentFontSize: 20,
      studentNameTop: 0,
      studentNameLeft: 0,
      studentNameColor: '#000000FF',
      pickStudentColor: '000000FF',

      courseFontSize: 16,
      courseNameTop: 0,
      courseNameLeft: 0,
      courseNameColor: '#000000FF',
      pickCourseColor: '#000000FF',

      defaultHexColor: '#000000FF',

      dateFontSize: 14,
      date: '',
      dateTop: 0,
      dateLeft: 0,
      dateColor: '#000000FF',
      pickDateColor: '#000000FF',

      groupRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.userGroupRequired'
          ),
        // v => (v && v.length >= 2) || "Category must be at least 2 characters"
      ],
      select: false,

      // modal Company
      headers: [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.organizationLogo'
          ),
          align: 'start',
          sortable: false,
          value: 'logo',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.organizationName'
          ),
          value: 'title',
          sortable: false,
        },
        // { text: "Actions", value: "actions", sortable: false }
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.add'
          ),
          value: 'actions',
          sortable: false,
        },
      ],
      searchdata: '',
      pageCount: 1,
      limit: 10,
      params: {},
      selectNewCompany: [],
      dialogStudentColor: false,
      dialogCourseColor: false,
      dialogDateColor: false,

      loadingbtn: false,
      searchSkill: null,

      oldLengthSkill: 0,
      newLengthSkill: 0,
      dialogActiveCourse: false,
      dialogUnActiveCourse: false,
      dialogCantPublic: false,
      messageCantPublic: '',
      staticActiveStatus: false,
    };
  },
  props: {
    fontsize: {
      type: Number,
      default: 0,
    },
    marginbottom: {
      type: Number,
      default: 0,
    },
    marginleft: {
      type: Number,
      default: 0,
    },
    changeTab: {
      type: Function,
    },
  },
  computed: {
    studentNameStyleFont() {
      return {
        fontsize: `${this.studentFontSize}px`,
      };
    },
    studentNameStyle() {
      return {
        marginbottom: `${this.studentNameTop}%`,
        marginleft: `${this.studentNameLeft}%`,
      };
    },
    courseNameStyleFont() {
      return {
        fontsize: `${this.courseFontSize}px`,
      };
    },
    courseNameStyle() {
      return {
        marginbottom: `${this.courseNameTop}%`,
        marginleft: `${this.courseNameLeft}%`,
      };
    },
    dateStyleFont() {
      return {
        fontsize: `${this.dateFontSize}px`,
      };
    },
    dateStyle() {
      return {
        marginbottom: `${this.dateTop}%`,
        marginleft: `${this.dateLeft}%`,
      };
    },
    fileRules() {
      const rules = [];

      if (this.courseID === undefined) {
        const rule =
          this.imgURL.length > 0 ||
          this.$vuetify.lang.t('$vuetify.plsChooseFile');
        this.imgURLCertificate.length > 0 ||
          this.$vuetify.lang.t('$vuetify.plsChooseFile');
        // const rule2 = this.imgURL.size < 5000000 || "Image size should be less than 5 MB!"
        rules.push(rule);
        // rules.push(rule2);
      }

      if (this.courseID !== undefined) {
        const rule =
          this.imgURL.length > 0 ||
          this.$vuetify.lang.t('$vuetify.plsChooseFile');
        this.imgURLCertificate.length > 0 ||
          this.$vuetify.lang.t('$vuetify.plsChooseFile');
        // const rule2 = this.imgURL.size < 5000000 || "Image size should be less than 5 MB!"
        // rules.push(rule2);
        rules.push(rule);
      }

      return rules;
    },
    skillRules() {
      const rules = [];
      if (this.courseID === undefined) {
        const rule =
          this.selectedSkills.length > 0 ||
          this.$vuetify.lang.t('$vuetify.plsChooseSkill');
        rules.push(rule);
      }

      if (this.courseID !== undefined) {
        const rule =
          this.selectedSkills.length > 0 ||
          this.$vuetify.lang.t('$vuetify.plsChooseSkill');
        rules.push(rule);
      }

      return rules;
    },
    // gradeRules() {
    //   const rules = [];
    //   if (this.courseID === undefined) {
    //     const rule =
    //       this.selectedGrade.length > 0 ||
    //       this.$vuetify.lang.t('$vuetify.plsChooseLevel');
    //     rules.push(rule);
    //   }

    //   if (this.courseID !== undefined) {
    //     const rule =
    //       this.selectedGrade.length > 0 ||
    //       this.$vuetify.lang.t('$vuetify.plsChooseLevel');
    //     rules.push(rule);
    //   }

    //   return rules;
    // },
  },
  watch: {
    selectedSkills() {
      this.newLengthSkill = this.selectedSkills.length;
      this.searchSkill = null;
    },
    async searchSkill(value) {
      this.skills = [];
      this.oldLengthSkill = this.selectedSkills.length;
      if (value != null) {
        if (value.length > 0) {
          let result = await loadSkillList({ search: value, limit: 10 });
          await result.data.forEach(async (skillItem) => {
            this.skills.push(skillItem);
          });
          await this.onSkillChange();
        }
      }
    },
  },
  methods: {
    checkMinPrice() {
      if (this.priceCourse < 0) this.priceCourse = 1;
    },
    checkMinDay() {
      if (this.durationTypeDay < 0) this.durationTypeDay = 1;
    },
    // async preview(event) {
    //   /*if (this.imageFile != null) {
    //     this.imgURL = await this.uploadImg(this.imageFile);
    //     this.imgPreview = this.imgURL;
    //     this.imageReady = true;
    //   } else {
    //     this.imageReady = false;
    //   }*/
    //   let file = event.target.files[0];
    //   this.imageFile = file;
    //   //this.fileName = file.name
    //   this.imgPreview = URL.createObjectURL(file);
    //   this.imageReady = true;
    // },
    async preview(event) {
      let file = event.target.files[0];
      this.imageFile = file;
      this.imgPreview = await URL.createObjectURL(file);
      this.imageName = file.name;
      if (this.imgPreview) {
        this.imageReady = true;
      }
      this.imgBool = true;
      this.universalHistory('EDIT_COURSE_COVER');
    },
    async preview2(event) {
      let file = event.target.files[0];
      this.imageFile2 = file;
      this.imgPreview2 = await URL.createObjectURL(file);
      this.imageName2 = file.name;
      if (this.imgPreview2) {
        this.imageReady2 = true;
      }
      this.imgBool2 = true;
    },

    async onSkillChange() {
      this.logHistory('EDIT_TAG');
      if (this.selectedSkills[this.selectedSkills.length - 1]) {
        this.selectedSkills[
          this.selectedSkills.length - 1
        ] = this.selectedSkills[this.selectedSkills.length - 1].replace(
          /\s/g,
          ''
        );
      }
      for (var i = 0; i < this.selectedSkills.length; i++) {
        if (this.selectedSkills[i]._id == null) {
          let tempSkill = this.selectedSkills[this.selectedSkills.length - 1];
          let position = -1;
          for (var j = 0; j < this.skills.length; j++) {
            if (this.skills[j].title == tempSkill) {
              position = j;
            }
          }
          let result;
          if (position > -1) {
            result = this.skills[position]._id;
          } else {
            if (
              this.selectedSkills[this.selectedSkills.length - 1] != '' &&
              this.selectedSkills[this.selectedSkills.length - 1] != ' '
            ) {
              result = await this.insertSkill(
                cleaningData(
                  this.selectedSkills[this.selectedSkills.length - 1]
                )
              );
            }
          }
          if (result) {
            this.selectedSkills[this.selectedSkills.length - 1] = {
              title: tempSkill,
              _id: result,
            };
          }
          // else {
          //   this.selectedSkills.pop();
          // }
        }
        this.newLengthSkill = this.selectedSkills.length;
      }
      if (this.newLengthSkill !== this.oldLengthSkill) {
        this.searchSkill = null;
      }
    },
    universalHistory(action) {
      this.logHistory(action);
    },
    logHistory(action) {
      const history = {
        action,
        time: Math.floor(Date.now() / 1000),
        created_by: this.$store.state._id,
      };
      const isDuplicate =
        this.history.length > 0 &&
        this.history.some((h) => !h._id && h.action === action);
      if (isDuplicate) {
        const editIndex = this.history.findIndex((h) => h.action === action);
        if (editIndex) {
          this.history[editIndex] = history;
        }
      } else {
        this.history.push(history);
      }
    },
    async onLevelChange() {
      this.logHistory('EDIT_LEVEL');
    },
    async onTagChange() {
      this.logHistory('EDIT_TAG');
      for (var i = 0; i < this.selectedTags.length; i++) {
        if (!this.selectedTags[i]._id) {
          let tempSkill = this.selectedTags[this.selectedTags.length - 1];
          let position = -1;
          for (var j = 0; j < this.tags.length; j++) {
            if (this.tags[j].title == tempSkill) {
              position = j;
            }
          }
          let result;
          if (position > -1) {
            result = this.tags[position]._id;
          } else {
            let addedSkill = await insertTag({
              title: cleaningData(
                this.selectedTags[this.selectedTags.length - 1]
              ),
            });
            result = addedSkill.data._id;
          }

          this.tags = await loadTagList();
          this.selectedTags[this.selectedTags.length - 1] = {
            title: tempSkill,
            _id: result,
          };
        }
      }
    },
    refreshPage() {
      this.alert = false;
      this.initialize();
    },
    onEditorBlur(quill) {
      console.log('editor blur!', quill);
    },
    onEditorFocus(quill) {
      console.log('editor focus!', quill);
    },
    onEditorChange({ html }) {
      this.content = html;
      this.universalHistory('EDIT_DESCRIPTION');
    },
    checkOwner() {
      this.setOwner == false ? (this.selectInstructor = []) : '';
    },
    async initialize() {
      this.courseID = this.$route.query.id;
      this.paramsInstructor = {
        search: null,
        sort: 'created_at',
        sortby: -1,
        page: 1,
        limit: 1000,
        active: 'null',
        isTeacher: 'y',
      };
      let resultTeacher = await getUserTeacherList(this.paramsInstructor);
      this.categories = await loadCategory();
      console.log(this.categories);
      // this.skills = await loadSkill();
      let grade = await loadGradeList();
      this.grades = grade.data;

      const tags = await loadTagList();
      this.tags = tags.data;

      if (this.courseID != null && this.courseID != undefined) {
        let params = {
          id: this.courseID,
        };

        await this.getCourseDetail(params);
        this.isEdit = true;

        console.log(this.detail);
        console.log(this.selectInstructor);
        if (this.selectInstructor.length > 0) {
          if (
            this.selectInstructor.findIndex(
              (instructor) => instructor._id._id == this.$store.state._id
            ) > -1
          ) {
            this.setOwner = false;
          } else {
            this.selectInstructor = this.selectInstructor[0]._id._id;
            this.setOwner = true;
          }
        }
      } else {
        this.setOwner = false;
      }
      this.getUserGroup();

      let tmpOwner = this.owner.length > 0 ? this.owner[0]._id._id : '';
      let resultIsTeacher = await resultTeacher.data.filter(
        (filter) => filter.isTeacher === 'y' && filter._id !== tmpOwner
      );
      await resultIsTeacher.forEach(async (instructor) => {
        this.instructorList.push({
          id: instructor._id,
          fullName: instructor.firstName + ' ' + instructor.lastName,
        });
      });
    },
    goBack() {
      //this.$router.go(-1);
      this.$router.push({
        path: '/course',
      });
    },
    async getUserGroup() {
      if (this.$store.state.permission.superAdmin === false) {
        this.listCompany = await getUserGroupCompany();
      } else {
        this.listCompany = await getlistCompany();
      }

      this.listFilterCompany = await this.listCompany.data.map(
        (company) => company.companies
      );

      this.courseID = this.$route.query.id;
      if (this.courseID != null) {
        let resultCompany = await getDetailCompany({
          idcourse: this.courseID,
        });

        this.listDetailCompany = resultCompany;

        let tempCompanyId = this.listDetailCompany.map(
          (company) => company.companies._id
        );

        this.listFilterCompany = this.listFilterCompany.filter(
          (isSelectCom) =>
            tempCompanyId.findIndex(
              (companyId) => companyId === isSelectCom._id
            ) === -1
        );

        this.listDetailTemp = [];
        for (let i = 0; i < this.listDetailCompany.length; i++) {
          let userGroup = await this.listDetailCompany[i].user_groups.map(
            (groups) => groups._id
          );
          await this.listDetailTemp.push({
            user_groups: userGroup,
          });
        }
        this.userGroupSelectByAdmin = this.listDetailTemp[
          this.indexSelectByAdmin
        ].user_groups;
      }

      let myCompanyIndex = await this.listDetailCompany.findIndex(
        (company) => company.companies._id === this.$store.state.company._id
      );

      let indexGroupByOwn = await this.listCompany.data.findIndex(
        (company) => company.companies._id === this.$store.state.company._id
      );
      this.userGroup =
        indexGroupByOwn !== -1
          ? await this.listCompany.data[indexGroupByOwn].user_groups
          : '';
      this.userGroup =
        indexGroupByOwn !== -1
          ? await this.userGroup.filter((group) => group.active !== false)
          : [];

      this.userGroup =
        this.userGroup.length > 0 ? await this.addAllGroup(this.userGroup) : [];
      this.userGroupSelect = this.listDetailTemp[myCompanyIndex]
        ? this.listDetailTemp[myCompanyIndex].user_groups
        : [];

      this.userGroupAllAtIndex = [];
      await this.listCompany.data.forEach(async (company) => {
        let arrayGroup = [];
        company.user_groups.forEach(async (group) => {
          group.child_User_Group.length === 0
            ? await arrayGroup.push({
                title: group.title,
                _id: group._id,
              })
            : null;
          group.child_User_Group.forEach(async (child) => {
            child.child_User_Group.length === 0
              ? await arrayGroup.push({
                  title: group.title + ' -> ' + child.title,
                  _id: child._id,
                })
              : null;
            child.child_User_Group.forEach(async (lastChild) => {
              await arrayGroup.push({
                title:
                  group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
                _id: lastChild._id,
              });
            });
          });
        });
        await this.userGroupAllAtIndex.push({
          user_groups: arrayGroup,
        });
      });
      this.indexSelectByAdmin = myCompanyIndex ? myCompanyIndex : 0;
      this.indexSelectIdForSearch = indexGroupByOwn ? indexGroupByOwn : 0;

      let arr = [];
      this.userGroupSelect.forEach((select) => {
        this.userGroupAllAtIndex[
          this.indexSelectIdForSearch
        ].user_groups.forEach((group) => {
          if (select == group._id) {
            arr.push({
              title: group.title,
              _id: group._id,
            });
          }
        });
      });

      this.userGroupSelect = arr;
    },
    removeByUser(item) {
      const index = this.userGroupSelect.indexOf(item._id);
      if (index >= 0) this.userGroupSelect.splice(index, 1);
    },
    removeByAdmin(item) {
      const index = this.userGroupSelectByAdmin.indexOf(item._id);
      if (index >= 0) this.userGroupSelectByAdmin.splice(index, 1);
    },
    addAllGroup(group) {
      return [
        {
          levelSub: 1,
          child_User_Group: group,
          _id: 'all',
          title: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.all'
          ),
        },
      ];
    },
    async onUpload() {
      this.categoryId = this.selectedCategories;
      // this.gradeId = this.selectedGrade;
      this.tagsId = this.selectedTags;
      this.instructorID = this.selectInstructor;

      let isValidForm = true;

      if (this.courseName.length > 2 && this.courseName.length <= 50) {
        isValidForm = true;
      } else {
        isValidForm = false;
      }

      if (this.categoryId) {
        isValidForm = true;
      } else {
        isValidForm = false;
      }

      if (this.gradeId) {
        isValidForm = true;
      } else {
        isValidForm = false;
      }

      if (this.selectedSkills.length > 0) {
        isValidForm = true;
      } else {
        isValidForm = false;
      }

      if (this.setOwner && this.selectInstructor.length > 0) {
        isValidForm = true;
      } else if (!this.setOwner) {
        isValidForm = true;
      } else {
        isValidForm = false;
      }

      if (isValidForm) {
        this.loadingbtn = true;
        this.skillsId = [];
        for (var i = 0; i < this.selectedSkills.length; i++) {
          this.skillsId.push(this.selectedSkills[i]._id);
        }

        this.tagsId = [];
        for (var j = 0; j < this.selectedTags.length; j++) {
          this.tagsId.push(this.selectedTags[j]._id);
        }

        let course;
        if (this.courseID != null) {
          if (this.imageFile != null) {
            await this.uploadImg(this.imageFile);
          }
          if (this.imageFile2 != null) {
            await this.uploadImg2(this.imageFile2);
          }

          course = await this.updateCourse(this.courseID);
        } else {
          if (this.imageFile != null) {
            await this.uploadImg(this.imageFile);
          }
          if (this.imageFile2 != null) {
            await this.uploadImg2(this.imageFile2);
          }

          course = await this.insertCourse();

          this.courseID = await course._id;
          this.loadingbtn = false;
          await this.$router.replace({
            query: {
              id: course._id,
            },
          });
          this.changeTab('lecture');
          await this.initialize();
        }

        if (course != false) {
          this.dialogSuccess = true;
          this.history = course.history;
        }

        let resultRoom = await getRoom({
          idcourse: this.$route.query.id,
        });
        if (resultRoom.length == 0) {
          await insertRoom({
            idcourse: this.courseID,
            title: this.courseName,
            idteacher: this.$store.state._id,
            isClose: false,
            permissionedit: true,
            active: true,
            externalAccess: false,
            autoAccept: false,
          });
        }

        let groupCompany = [];
        await this.listDetailTemp.forEach((company, index) => {
          index !== this.indexSelectByAdmin
            ? groupCompany.push(...company.user_groups)
            : '';
        });
        // user
        if (this.$store.state.permission.superAdmin === false) {
          await setUserGroupToCourse({
            idcourse: this.courseID,
            usergroup: this.userGroupSelect.map((group) => group._id),
          });
        }
        // admin
        else if (this.$store.state.permission.superAdmin === true) {
          await setUserGroupToCourseByAdmin({
            idcourse: this.courseID,
            usergroup: [...groupCompany, ...this.userGroupSelectByAdmin],
          });
        }
        // let roomB2CList = resultRoom.filter(
        //   room => room.externalAccess == true
        // );
        // if (this.selectTrade == "2") {
        //   if (resultRoom.length == 0) {
        //     let result = await insertRoom({
        //       idcourse: this.courseID,
        //       title: "B2C Room",
        //       idteacher: this.$store.state._id,
        //       isClose: false,
        //       permissionedit: true,
        //       active: true,
        //       externalAccess: false,
        //       autoAccept: false
        //     });
        //   } else {
        //     let result = await updateRoomActive({
        //       idroom: resultRoom[0]._id,
        //       active: true
        //     });
        //   }
        // } else {
        //   if (resultRoom.length > 0) {
        //     let result = await updateRoomActive({
        //       idroom: resultRoom[0]._id,
        //       active: false
        //     });
        //   }
        // }
        this.loadingbtn = false;
      }
    },
    async insertSkill(skill) {
      let addedSkill = await insertSkill({
        title: skill,
      });
      return addedSkill._id;
    },
    async uploadImg(file) {
      this.showUploadPercent = true;
      let formData = new FormData();
      formData.append('fileupload', file);
      formData.append('title', file.name);
      await axios
        .post(`${domain}/uploadfile/public/image/course`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            this.imgPreview = response.data.result;
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!', e);
        });
    },
    async uploadImg2(file) {
      this.showUploadPercent = true;
      let formData = new FormData();
      formData.append('fileupload', file);
      formData.append('title', file.name);
      await axios
        .post(`${domain}/uploadfile/public/image/course`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            this.imgPreview2 = response.data.result;
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!', e);
        });
    },
    async insertCourse() {
      let status = null;
      let insertValue = {
        title: cleaningData(this.courseName),
        description: this.description,
        categories: [this.categoryId],
        skills: this.skillsId,
        grades: this.gradeId,
        tags: this.tagsId,
        image: this.imgPreview,
        haveDashboard: this.haveDashboard,
        useBoard: this.useBoard,
        haveInbox: this.haveInbox,
        learningOrder: this.learningOrder,
        localizations: [
          {
            title: cleaningData(this.courseName),
            lang: 'th',
          },
          {
            title: cleaningData(this.courseNameEng),
            lang: 'en',
          },
        ],
        certificate: this.certificate,
        percentCertificate:
          this.certificate == true ? this.percentCertificate : 80,
        urlCertificateTemplate:
          this.certificate == true ? this.imgPreview2 : '',
        // styleCertificate: {
        //   studentName: {
        //     certificateStudentName: this.certificateStudentName,
        //     studentFontSize: this.studentFontSize,
        //     studentNameTop: this.studentNameTop,
        //     studentNameLeft: this.studentNameLeft,
        //     studentNameColor: this.studentNameColor,
        //   },
        //   courseName: {
        //     certificateCourseName: this.certificateCourseName,
        //     courseFontSize: this.courseFontSize,
        //     courseNameTop: this.courseNameTop,
        //     courseNameLeft: this.courseNameLeft,
        //     courseNameColor: this.courseNameColor,
        //   },
        //   date: {
        //     certificateDate: this.certificateDate,
        //     dateFontSize: this.dateFontSize,
        //     date: this.date,
        //     dateTop: this.dateTop,
        //     dateLeft: this.dateLeft,
        //     dateColor: this.dateColor,
        //   },
        // },
      };
      insertValue.admins = this.admins;
      insertValue.history = this.history;
      console.log(this.detail);
      // insertValue.owner_by_students = [this.detail.owner_by_students[0]];
      if (this.setOwner) {
        insertValue.owner_by_students[1] = {
          initCreate: false,
          _id: this.selectInstructor,
        };
      }
      status = await insertCourse(insertValue);
      console.log(status);
      if (status.code == 403) {
        this.dialogAddFail = true; //กรณี error อื่น
        return false;
      } else {
        return status;
      }
    },
    async updateCourse(courseID) {
      let status = null;
      let valueData = {
        ...this.detail,
        id: courseID,
        title: cleaningData(this.courseName),
        description: this.description,
        categories: [this.categoryId],
        skills: this.skillsId,
        grades: this.gradeId,
        tags: this.tagsId,
        image: this.imgPreview,
        haveDashboard: this.haveDashboard,
        useBoard: this.useBoard,
        haveInbox: this.haveInbox,
        learningOrder: this.learningOrder,
        localizations: [
          {
            title: cleaningData(this.courseName),
            lang: 'th',
          },
          {
            title: cleaningData(this.courseNameEng),
            lang: 'en',
          },
        ],
        certificate: this.certificate,
        percentCertificate:
          this.certificate == true ? this.percentCertificate : 0,
        urlCertificateTemplate:
          this.certificate == true ? this.imgPreview2 : '',
        // styleCertificate: {
        //   studentName: {
        //     certificateStudentName: this.certificateStudentName,
        //     studentFontSize: this.studentFontSize,
        //     studentNameTop: this.studentNameTop,
        //     studentNameLeft: this.studentNameLeft,
        //     studentNameColor: this.studentNameColor,
        //   },
        //   courseName: {
        //     certificateCourseName: this.certificateCourseName,
        //     courseFontSize: this.courseFontSize,
        //     courseNameTop: this.courseNameTop,
        //     courseNameLeft: this.courseNameLeft,
        //     courseNameColor: this.courseNameColor,
        //   },
        //   date: {
        //     certificateDate: this.certificateDate,
        //     dateFontSize: this.dateFontSize,
        //     date: this.date,
        //     dateTop: this.dateTop,
        //     dateLeft: this.dateLeft,
        //     dateColor: this.dateColor,
        //   },
        // },
      };
      valueData.admins = this.admins;
      valueData.history = this.history;
      valueData.owner_by_students = [this.detail.owner_by_students[0]];
      // if (this.setOwner) {
      //   valueData.owner_by_students[1] = {
      //     initCreate: false,
      //     _id: this.selectInstructor,
      //   };
      // }
      let instuctorCourse = this.detail.owner_by_students.filter(
        (d) => !d.initCreate
      );
      if (instuctorCourse.length> 0) {
        valueData.owner_by_students[1] = {
          initCreate: false,
          _id: instuctorCourse[0]._id._id,
        };
      }
      status = await updateCourse(valueData);
      if (status.code == 403) {
        this.dialogAddFail = true; //กรณี error อื่น
        return false;
      } else {
        return status;
      }
    },
    async getCourseDetail(params) {
      let detail = await getCourseById(params);
      console.log(detail);
      this.detail = detail;
      this.imgPreview = detail.image;
      this.admins = this.detail.admins;
      this.history = this.detail.history;
      this.imageFile;
      this.imgURL = detail.image;
      this.imgURLCertificate = detail.urlCertificateTemplate;
      this.imageReady = true;
      this.courseName = detail.title;
      this.activeStatus = detail.active;
      this.staticActiveStatus = detail.active;
      this.description = detail.description;
      this.selectedSkills = detail.skills;
      this.selectedTags = detail.tags || [];
      this.selectedCategories = detail.categories[0];
      // this.selectedGrade = detail.grades;
      this.haveDashboard = detail.haveDashboard;
      this.useBoard = detail.useBoard;
      this.haveInbox = detail.haveInbox;
      this.learningOrder = detail.learningOrder;
      this.selectInstructor = detail.owner_by_students.filter(
        (d) => !d.initCreate
      );
      this.owner = detail.owner_by_students.filter((d) => d.initCreate);
      console.log(this.owner[0]._id._id);
      if (detail.localizations.length) {
        this.courseNameEng = detail.localizations[1].title;
      } else {
        this.courseNameEng = detail.title;
      }
      this.certificate = detail.certificate;
      this.percentCertificate = detail.percentCertificate;
      this.imgPreview2 = detail.urlCertificateTemplate;
      this.imageReady2 = true;
      // this.setPercentTop = detail.styleCertificate.setPercentTop;
      // this.setPercentLeft = detail.styleCertificate.setPercentLeft;
      if (detail.styleCertificate) {
        if (detail.styleCertificate.studentName) {
          this.studentFontSize =
            detail.styleCertificate.studentName.studentFontSize ||
            this.studentFontSize;
          this.studentNameTop =
            detail.styleCertificate.studentName.studentNameTop ||
            this.studentNameTop;
          this.studentNameLeft =
            detail.styleCertificate.studentName.studentNameLeft ||
            this.studentNameLeft;
          this.studentNameColor =
            detail.styleCertificate.studentName.studentNameColor ||
            this.studentNameColor;
          this.certificateStudentName =
            detail.styleCertificate.studentName.certificateStudentName ||
            this.certificateStudentName;
        }

        if (detail.styleCertificate.courseName) {
          this.courseFontSize =
            detail.styleCertificate.courseName.courseFontSize ||
            this.courseFontSize;
          this.courseNameTop =
            detail.styleCertificate.courseName.courseNameTop ||
            this.courseNameTop;
          this.courseNameLeft =
            detail.styleCertificate.courseName.courseNameLeft ||
            this.courseNameLeft;
          this.courseNameColor =
            detail.styleCertificate.courseName.courseNameColor ||
            this.courseNameColor;
          this.certificateCourseName =
            detail.styleCertificate.courseName.certificateCourseName ||
            this.certificateCourseName;
        }

        if (detail.styleCertificate.date) {
          this.certificateDate =
            detail.styleCertificate.date.certificateDate ||
            this.certificateDate;
          this.dateFontSize =
            detail.styleCertificate.date.dateFontSize || this.dateFontSize;
          this.date = detail.styleCertificate.date.date || this.date;
          this.dateTop = detail.styleCertificate.date.dateTop || this.dateTop;
          this.dateLeft =
            detail.styleCertificate.date.dateLeft || this.dateLeft;
          this.dateColor =
            detail.styleCertificate.date.dateColor || this.dateColor;
        }
      }
    },
    openModalStatus() {
      if (this.activeStatus) {
        this.dialogActiveCourse = true;
      } else {
        this.dialogUnActiveCourse = true;
      }
    },
    cancelModalStatus() {
      this.dialogUnActiveCourse = false;
      this.dialogActiveCourse = false;
      this.activeStatus = !this.activeStatus;
    },
    async courseActive() {
      if (this.activeStatus) {
        let canPublicCourseStatus = await this.canPublicCourse();
        if (!canPublicCourseStatus) {
          this.cancelModalStatus();
          this.dialogCantPublic = true;
          return;
        }
      }
      let status = await updateActive({
        id: this.courseID,
        active: this.activeStatus,
      });

      this.dialogUnActiveCourse = false;
      this.dialogActiveCourse = false;

      if (status) {
        this.dialogSuccess = true;
      }
    },
    async canPublicCourse() {
      let resultCourseDetail = await getCourseById({
        id: this.courseID,
      });
      let resultRoom = await getRoom({
        idcourse: this.courseID,
      });

      let resultLive = await getLive({
        idcourses: this.courseID,
      });

      if (
        resultRoom.length <= 0 ||
        resultRoom.filter((room) => room.active == true).length <= 0
      ) {
        this.messageCantPublic =
          'คอร์สเรียนต้องมีกลุ่มห้องเรียนที่เปิดอย่างน้อย 1 กลุ่ม';
        return false;
      } else if (
        resultCourseDetail.sections.length > 0 &&
        resultCourseDetail.sections[0].lectures.length <= 0 &&
        resultLive.filter((live) => live.active == true).length <= 0
      ) {
        this.messageCantPublic =
          'บทเรียนต้องมีเนื้อหาอย่างน้อย 1 บท หรือมีการถ่ายทอดสดอย่างน้อย 1 ครั้ง';
        return false;
      } else if (resultCourseDetail.sections.length <= 0) {
        this.messageCantPublic = 'ไม่มีบทเรียน';
        return false;
      } else {
        return true;
      }
    },
  },
  async mounted() {
    await this.initialize();
  },
  async onTextChange(event) {
    console.log(event);
  },
};
</script>

<style scoped>
.container1 {
  /* position: relative; */
}
.box {
  width: 100%;
  height: 100%;
  opacity: 0.9;
  position: absolute;
}
.layer1 {
  z-index: 1;
  /* position: absolute; */
  /* bottom: 0%; */
  /* left: 0%; */
}
.layer2 {
  z-index: 2;
  /* position: absolute; */
  /* bottom: 0%; */
  /* left: 0%; */
}
.layer3 {
  z-index: 3;
  /* position: absolute; */
  /* bottom: 0%; */
  /* left: 0%; */
}
.layer1,
.layer2,
.layer3 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.dateinput {
  background-color: white;
  height: 38px;
}
.card-style {
  margin-bottom: 25%;
}
.sheet-style {
  justify-content: center;
  background: content-box;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 170px !important;
}

.btn-choose {
  color: rgba(0, 0, 0, 0.65);
  background-color: white;
  padding: 8px 20px;
  font-size: 16px;
  width: 170px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}

.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}

.upload-btn-wrapper input[type='file']:hover {
  cursor: pointer;
}

.text-custom {
  color: rgba(0, 0, 0, 0.45);
}

.editor {
  /*min-height: 250px;
   margin-bottom: 70px;*/
  background: #fff;
}

.paddingCard {
  padding: 5px;
}

.labelExplan {
  text-align: justify;
  font-size: 17px;
}

.border-info {
  border: 2px solid #1976d2;
}
</style>
<style scoped lang="scss">
.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed
  .v-select__selections {
  min-height: 60px;
}

.border-card {
  border: 1px dashed #80808040 !important;
  /* -webkit-box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important; */
  /* box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important; */
}

.image-preview {
  min-height: 400px;
  border: 1px dashed rgba(0, 0, 0, 0.15) !important;
  background: #ebedf0;
}
.image-preview2 {
  border: 1px dashed rgba(0, 0, 0, 0.15) !important;
  background: #ebedf0;
}

.custom-alert {
  &::before {
    background-color: transparent;
  }
}

.custom-alert .v-alert__content {
  color: rgba(0, 0, 0, 0.65) !important;
}

.custom-button {
  border-radius: 4px;
  border: solid 1px #d9d9d9;
  background-color: #ffffff;
  color: rgba(0, 0, 0, 0.45);
}

.custom-button .v-btn__content {
  color: rgba(0, 0, 0, 0.65) !important;
}
</style>
<style>
.append-outer-rec {
  margin-top: -17px !important;
}

/* .append-outer-rec.date{
  margin-top: -1px !important;
} */

.detail-editor {
  border-radius: 4px;
}

.detail-editor .ql-container {
  min-height: 175px !important;
}

.ql-container.ql-snow {
  border: 1px solid #e0e0e0;
  border-radius: 0 0 4px 4px;
}

.ql-toolbar.ql-snow {
  border: 1px solid #e0e0e0;
  border-radius: 4px 4px 0 0;
}

.text-custom-title {
  color: #4a4a4a;
}
</style>
